import "../style/instructor-page.css";
import StyledPage from "./StyledPage";
import Bg1 from "../assets/instructor-bg1.svg";
import Bg2 from "../assets/instructor-bg2.svg";
import I1 from "../assets/1.jpeg";
import I2 from "../assets/2.jpeg";
import I3 from "../assets/3.jpeg";
import I4 from "../assets/4.jpeg";
import I5 from "../assets/5.jpeg";
import I6 from "../assets/6.jpeg";
import I7 from "../assets/7.jpeg";
import I8 from "../assets/8.jpeg";
import I9 from "../assets/9.jpeg";
import I10 from "../assets/10.jpeg";
import I11 from "../assets/11.jpeg";
import I12 from "../assets/12.jpeg";

type InstructorInfo = {
  name: string;
  img: any;
  content: string;
}
const InstructorPage = () => {
  const info: InstructorInfo[] = [
    {
      name: '나경민', img: I1,
      content: '아이의 첫 경험은 평생의 기억이 된다고 믿습니다. 유아체육 경험이 풍부한 태권도 사범 출신으로, 아이 한 명 한 명의 성향에 귀 기울이며 아이와 부모 모두가 만족할 수 있는 수업을 만들어가겠습니다. \n' +
        '좋은 수업은 보이지 않는 준비에서 시작된다는 교육관 아래, 강사가 온전히 아이에게 집중할 수 있는 환경을 지켜가겠습니다.'
    },
    {
      name: '윤봉열', img: I2, content: '모든 아이를 제 자식처럼 생각하며 강습합니다.\n' +
        '강사들은 체계적인 교육 시스템 속에서 관리됩니다.\n' +
        '주 2회 정기 교육과 피드백으로 실력을 꾸준히 검증합니다.\n'
    },
    {
      name: '이한우', img: I3,
      content: '처음 스키를 배우는 아이들이 즐거움과 친목 속에서 자연스럽게 배울 수 있도록 지도합니다.\n' +
        '도전과 성취의 기쁨을 느낄 수 있도록 눈높이에 맞춘 재미있는 강습을 진행합니다.\n' +
        '스키와 함께하는 행복한 추억을 만들어 드리기 위해 항상 최선을 다하겠습니다.'
    },
    {
      name: '손나현', img: I4,
      content: '스키가 처음이어도 괜찮습니다.\n' +
        '기본부터 차근차근, 아이의 이해 속도와 성향에 맞춰 친절하게 진행합니다.\n' +
        '기술뿐만 아니라 배우는 시간 자체가 소중한 경험이 되도록, 부담 없이 웃으며 즐길 수 있는 스키 강습 ❄️\n' +
        '이번 겨울, 아이의 작은 도전이 큰 변화가 되도록 함께하겠습니다.'
    },
    {
      name: '장한나', img: I5,
      content: '아이가 스키를 좋아하게 되는 순간은 잘 타게 됐을 때보다, 믿고 따라갈 수 있는 선생님을 만났을 때라고 느껴요 😊\n' +
        '기초부터 상급까지 무리하지 않게, 안전을 먼저 생각하면서 우리 아이 성향에 맞춰 차근차근 함께 할게요🫶\n' +
        '“또 타고 싶어요”라는 말이 자연스럽게 나오는 수업, 이번 겨울 저와 함께 스키 타면서 즐겁고 특별한 추억 만들어 볼까요?? ⛷️❄️'
    },
    {
      name: '전준하', img: I6,
      content: '어릴때부터 아이들에게 성취감과 경험은 중요하다고 생각합니다.\n' +
        '아이들이 이번겨울 스키와 보드를 경험하면서 겨울 스포츠의 재미뿐 아니라 자신이 성장해나가는 성취감도 함께 느낄 수 있는 체계적이고 즐거운 강습과 탄탄한 피드백으로 저와 함께 쌓아갈 수 있도록 최선을 다하겠습니다!!'
    },
    {
      name: '진상원', img: I7,
      content: '어린 시절부터 도전과 성취의 가치를 배우며 성장해 왔습니다. \n' +
        '아이들이 처음 스키를 마주하는 순간부터 성공의 기쁨을 느끼는 과정까지 함께 하겠습니다. \n' +
        '단순한 기술 전달이 아닌, 도전하는 과정 자체를 즐길 수 있도록 지도하겠습니다. \n' +
        '항상 아이들의 눈높이에서 생각하고, 웃음과 배움이 공존하는 즐거운 강습을 만들어가겠습니다.'
    },
    {
      name: '오하나', img: I8,
      content: '아이들에게 최고의 겨울 선물을 약속합니다:) 다정한 눈높이 소통으로 행복한 추억을 남기고, 기본부터 똑바로 가르치는 열정적인 강습을 보여드리겠습니다!'
    },
    {
      name: '송아현', img: I9,
      content: '안전과 기본기를 중심으로 강습을 진행하는 스키 강사 아현입니다,\n' +
        '수강생의 체력과 성향을 고려한 단계별 수업을 통해 처음 배우는 분과 아이들도 불안함 없이 스스로 컨트롤할 수 있는 스키 실력을 차근차근 완성해갈 수 있도록 지도하겠습니다'
    },
    {
      name: '최서우', img: I10,
      content: '아이 한 명 한 명의 속도를 존중하며 안전하게, 그리고 차분하게 수업합니다.\n' +
        '처음이라 긴장한 아이도 자연스럽게 웃으며 눈 위에 설 수 있도록 따뜻한 분위기 속에서 함께해요.\n' +
        '즐거움 속에서 기본기를 놓치지 않고, 아이에게는 좋은 추억을 부모님께는 믿음이 남는 수업을 약속드리는 최서우 강사입니다.'
    },
    {
      name: '이서현', img: I11,
      content: '스키 실력뿐만 아니라, 아이가 배우는 그 시간 자체가 소중한 경험이 될 수 있도록 아이들마다의 다양한 성향과 속도를 존중하며 가장 올바른 방식으로 수업을 진행합니다. 이번 겨울 아이의 작은 도전이 큰 변화로 이어지는 특별한 순간을 함께 만들어드리겠습니다.'
    },
    {
      name: '박지안', img: I12,
      content: '아이들이 스키를 통해 조금씩 성장해가는 모습을 지켜보는 일에서 큰 보람을 느낍니다. 처음 설렘과 두려움이 공존하는 순간부터, 스스로 해냈다는 성취감을 느끼는 순간까지 그 모든 과정을 함께하며 아이들에게 즐거운 추억을 선물해주고 싶습니다. 아이들의 첫 스키 도전이 오래 기억에 남을 좋은 경험이 될 수 있도록 함께하겠습니다.'
    },
  ]
  return (
    <StyledPage>
      <div className={'instructor-page'}>
        <div className={'instructor-bg-frame'}>
          <img className={'instructor-bg'} src={Bg1} alt={''}/>
          <div className={'instructor-bg-flex'}>&nbsp;</div>
          <img className={'instructor-bg'} src={Bg2} alt={''}/>
        </div>
        <div className={'instructor-info-frame'}>
          <div className={'instructor-title'}> 블루스키스쿨
            <span style={{color: '#486CA0'}}>강사진</span>
          </div>
          <div className={'instructors'}>
            {info.map((instructor: InstructorInfo) => (
              <div className={'instructor'}>
                <img className={'i-img'} src={instructor.img} alt={''}/>
                <div className={'i-name'}> {instructor.name}</div>
                <div className={'i-content'}>
                  {instructor.content.split('\n').map((line: string) => (
                    <span> {line} <br/></span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </StyledPage>
  )
}

export default InstructorPage;